/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";

// Helper Imports
import { formatTrackingProperties } from "../../../../Helpers/formatters";

// Interactive Component Imports
import Loading from "../../../../Components/Interactive/Loading";

// MUI Imports
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const CustomerTrackingDetails = ({ allCustomerData, loading }) => {
  const [open, setIsOpen] = useState(true);
  const [toggleDropdown, setToggleDropdown] = useState(true);

  const {
    userTrackingInfo: { ipAddress, campaignId, orderId, scn, visitorHash, sca, leadId, c1 },
  } = allCustomerData;

  const isDefined = () => ipAddress && orderId && scn && visitorHash;

  return (
    <>
      <div
        className={`user-data-container ${
          open ? "show-tracking-widget" : "hide-tracking-widget"
        } ${isDefined() ? "" : "user-data-container-squeezed"}`}
        style={{ height: "1rem !important" }}
      >
        <div className="customer-widget-header">
          <p className="customer-widget-heading">Tracking</p>
          {isDefined() && (
            <ArrowDropDownIcon
              onClick={() => {
                setIsOpen(!open);
                setToggleDropdown(!toggleDropdown);
              }}
              className={`arrow-dropdown ${
                toggleDropdown ? "arrow-open" : "arrow-close"
              }`}
            />
          )}
        </div>
        <div className={`data-push ${open ? "show-data" : "no-data"}`}>
          {loading ? (
            <div className="loading-widget">
              <Loading />
            </div>
          ) : isDefined() ? (
            formatTrackingProperties(
              ipAddress,
              campaignId,
              scn,
              visitorHash,
              sca,
              leadId,
              c1
            )
          ) : (
            <h3 style={{ fontSize: "1rem" }}>No Tracking Data</h3>
          )}
        </div>
      </div>
    </>
  );
};

export default CustomerTrackingDetails;
